import { render, staticRenderFns } from "./GoodsExamine.vue?vue&type=template&id=610a7b14&scoped=true&"
import script from "./GoodsExamine.vue?vue&type=script&lang=js&"
export * from "./GoodsExamine.vue?vue&type=script&lang=js&"
import style0 from "./GoodsExamine.vue?vue&type=style&index=0&id=610a7b14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610a7b14",
  null
  
)

export default component.exports